<template> 
    <div class="group">
        <div class="title h_48">商品分组</div>
        <Card >
            <Button type="primary" class="addBtn" @click="addGroup">新建商品分组</Button>
            <Table  :columns="columns" :data="list">
                <template slot-scope="{ row }" slot="display">
                    <i-switch v-model="row.isDisplay" :true-value="1" :false-value="0" @on-change="changeDisplay(row)"/>
                </template>
                <template slot-scope="{row ,index }" slot="action">
                    <Button type="text"  @click="updateBtn(row,index)">编辑</Button> 
                    <Button type="text" class="delBtn" @click="del(row,index)">删除</Button>  
                </template>
            </Table>
        </Card>

        <Modal
            v-model="visible"
            title="添加商品分组"
             width="500"
            :footer-hide="true"
            >

            <Form  :label-width="100" >
                <FormItem label="* 分组名称：">
                    <Input v-model="form.name" placeholder="分组名称：" style="width:300px" />
                </FormItem>
                <FormItem label="排序：" >
                    <InputNumber v-model="form.sort" :max="10" :min="1" />  
                </FormItem>
                <FormItem label="是否显示：">
                    <i-switch v-model="form.isDisplay" :true-value="1" :false-value="0" />
                </FormItem>
                
            </Form>
            <div class="modal-footer">
                <Button type="primary" @click="submit">保存</Button>
                <Button style="marginLeft:20px" @click="visible=false">返回</Button>
            </div>
        </Modal>
    </div>
</template> 
<script>
import { mapState } from 'vuex'
import axios from 'axios'
    export default {
        name:'goods',
        data () {
            return { 
                guid:0,         //用户guid
                groupGuid:0,  //编辑时，分组的guid
                token:'',
                columns: [
                    {
                        title: '分组名字',
                        key: 'name'
                    },
                    {
                        title: '排序',
                        key: 'sort',
                        width:150
                    },
                    {
                        title: '商品数量',
                        key: 'count',
                        width:150
                    },
                     {
                        title: '隐藏',
                        key: 'isDisplay',
                        slot: 'display'
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                    },
                    {
                        title: '操作',
                        width:170,
                        slot: 'action',
                    }
                ],  
                form:{
                    name:'',
                    sort:0,
                    isDisplay:0
                },
                visible:false,
                isEdit:true,    //判断编辑还是 添加 
                list:[] 
            }
        },
        created(){
           this.getData()
            
        },
        methods: {
            //获取商品分组
            getData(){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/get'})
                    .then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.list = res.data.data
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            },
            //添加分组
            addGroup(){
                this.visible = true
                this.isEdit = false
                 this.form={
                    name:'',
                    sort:0,
                    isDisplay:0,
                }
            },
            //编辑按钮
            updateBtn(row){
                this.isEdit = true
                this.visible = true
                this.groupGuid = row.guid
                this.form={
                    name:row.name,
                    sort:row.sort,
                    isDisplay:row.isDisplay,
                }
            },
            //改变状态
            changeDisplay(row){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/update?route=/layout/goods/group/update',
                    method:'put',
                    data:{
                        guid: row.guid,
                        isDisplay:row.isDisplay
                    }
                }).then(res=>{
                    console.log(res)
                     if(res.status == 200 && res.data.code==1){
                        this.$Message.success(res.data.message);
                    }else{
                        this.$Message.error('网络异常');
                    }
                   
                })
            },
            //保存
            submit(){
                if(this.form.name ==''){
                    this.$Message.error('请先输入分组的名称')
                }else{
                    if(this.isEdit){
                        //编辑
                        let params = this.form
                        params.guid=this.groupGuid
                        axios({
                            url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/update?route=/layout/goods/group/update',
                            method:'PUT',
                            data:params
                        }).then(res=>{
                            if(res.status == 200 && res.data.code==1){
                                this.$Message.success('修改成功！');
                                this.getData()
                                this.visible = false
                            }else{
                                this.$Message.error('网络异常');
                            }
                        }) 
                    }else{
                        //新增
                        axios({
                            url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/add?route=/layout/goods/group/add',
                            method:'POST',
                            data:this.form
                        }).then(res=>{
                            if(res.status == 200 && res.data.code==1){
                                this.$Message.success('添加成功！');
                                this.getData()
                                this.visible = false
                            }else{
                                this.$Message.error('网络异常');
                            }
                        }) 
                    }
                }
            },
            //删除运费模板
            del(row,index){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/delete?route=/layout/goods/group/delete&guid='+row.guid,
                    method:'DELETE'
                }).then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.$Message.success('删除成功！')
                        const temList = []
                        this.list.forEach((item,i)=>{
                            if(i!=index){
                                temList.push(item)
                            }
                        })
                        this.list = temList
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            }
        },
          
    }
</script>  
<style scoped>
    .group{
        padding: 20px;
    }
    .title{
        color: #333;
    }
    .title::before{
        content: '\258D';
        color: #1abc9c;
        font-weight: 900;
        margin-right: 10px;
    }
    .addBtn{
        margin-bottom: 20px;
    }
    .group-image{
        width: 70px;
        height: 70px;
        margin: 20;
        margin: 10px;
    }
    .modal-header{
        color:'#2d8cf0';
        padding-bottom:5px ;
        margin-bottom: 20px;
        border-bottom: 1px solid #CCCCCC;
    }
    .modal-footer{
        text-align: right;
        background-color: white;
    }
    .tem-image{
        width: 200px;
        height: 100px;
        object-fit: contain;
    }
    .delBtn{
        color:red;
    }
</style>